import { ReloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ButtonProps } from "antd/lib";

const CbTableRefereshIconButton = ({
  style: externalStyles = {},
  className = "",
  ...props
}: ButtonProps) => {
  return (
    <Button
      {...props}
      className={className}
      type="default"
      style={{
        ...externalStyles,
      }}
      icon={<ReloadOutlined />}
    />
  );
};

export default CbTableRefereshIconButton;
